
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ComplianceTimelineEventResource,
  ValidationError,
} from '../models';
import {
    ComplianceTimelineEventResourceFromJSON,
    ComplianceTimelineEventResourceToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface RetrieveComplianceTimelineRequest {
    companyId: string;
}

/**
 * 
 */
export class ComplianceTimelineApi extends runtime.BaseAPI {

    /**
     * Retrieve compliance timeline for company
          */
    async retrieveComplianceTimelineRaw(requestParameters: RetrieveComplianceTimelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ComplianceTimelineEventResource>>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling retrieveComplianceTimeline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ComplianceTimelineEventResource>>({
            path: `/compliance/api/company/{companyId}/admin/timeline`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ComplianceTimelineEventResourceFromJSON);
        return response;
    }

    /**
     * Retrieve compliance timeline for company
          */
    async retrieveComplianceTimeline(requestParameters: RetrieveComplianceTimelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ComplianceTimelineEventResource>> {
        const response = await this.retrieveComplianceTimelineRaw(requestParameters, initOverrides);
        return response._data;
    }

}
